import type { ProfileRes } from 'src/entities/profile'
import type { IProfileGateway } from './ports/IProfileGateway'

// Сценарий: получить профиль текущего продавца.
export class GetProfile {
  constructor(private readonly gateway: IProfileGateway) {}

  execute(signal?: AbortSignal): Promise<ProfileRes> {
    return this.gateway.getProfile(signal)
  }
}
